const carouselItems = [
  {
    id: 1,
    tag: '重磅爆料',
    title: '顶流网红私生活大起底：直播间背后不为人知的真相',
    summary: '近期多位头部网红接连被曝出直播带货数据造假、私下人设崩塌等猛料，吃瓜群众直呼"没想到你是这样的"……',
    image: 'https://readdy.ai/api/search-image?query=A%20moody%20cinematic%20scene%20of%20a%20darkened%20live%20streaming%20studio%20with%20ring%20light%20and%20smartphone%20on%20tripod%2C%20mysterious%20atmosphere%2C%20warm%20accent%20lighting%2C%20dramatic%20shadows%2C%20film%20noir%20style%2C%20editorial%20photography%2C%20no%20human%20faces%20visible&width=800&height=500&seq=carousel-01-hl&orientation=landscape',
    date: '2026-07-28',
  },
  {
    id: 2,
    tag: '深度扒皮',
    title: '娱乐圈"姐妹花"反目成仇，朋友圈互撕截图流出',
    summary: '曾经形影不离的两位女星近日被曝关系破裂，多张私下聊天记录和朋友圈截图在粉丝圈疯传……',
    image: 'https://readdy.ai/api/search-image?query=A%20split%20composition%20showing%20two%20sides%20of%20a%20dramatic%20rift%2C%20warm%20golden%20light%20on%20one%20side%20and%20cool%20shadow%20on%20the%20other%2C%20shattered%20mirror%20metaphor%2C%20elegant%20but%20tense%20mood%2C%20editorial%20photography%20style%2C%20no%20human%20faces&width=800&height=500&seq=carousel-02-hl&orientation=landscape',
    date: '2026-07-27',
  },
  {
    id: 3,
    tag: '独家曝光',
    title: '知名选秀节目内定黑幕曝光，导师团队私下交易录音',
    summary: '一档热门选秀节目被内部人员曝出晋级名单早已内定，多段导师私下讨论"保送"选手的录音流出……',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20backstage%20scene%20of%20a%20talent%20show%20set%2C%20empty%20judges%20table%20with%20spotlights%2C%20scattered%20scorecards%2C%20dramatic%20theatrical%20lighting%2C%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20editorial%20photography&width=800&height=500&seq=carousel-03-hl&orientation=landscape',
    date: '2026-07-27',
  },
  {
    id: 4,
    tag: '热点追踪',
    title: '富二代网红豪车豪宅被查封，涉多起经济纠纷案件',
    summary: '以炫富走红的某平台百万粉丝博主近日被法院查封多处资产，背后涉及的投资纠纷和借贷问题浮出水面……',
    image: 'https://readdy.ai/api/search-image?query=A%20luxury%20sports%20car%20parked%20in%20front%20of%20a%20modern%20mansion%20at%20dusk%2C%20police%20tape%20across%20the%20gate%2C%20dramatic%20sky%2C%20moody%20atmosphere%2C%20editorial%20photography%20style%2C%20warm%20amber%20and%20crimson%20tones&width=800&height=500&seq=carousel-04-hl&orientation=landscape',
    date: '2026-07-26',
  },
  {
    id: 5,
    tag: '粉丝炸锅',
    title: '某男团队内霸凌视频流出，经纪公司紧急公关删帖',
    summary: '一段疑似男团成员在后台互相推搡辱骂的视频在社交平台疯传，粉丝后援会连夜发表联合声明……',
    image: 'https://readdy.ai/api/search-image?query=A%20tense%20backstage%20corridor%20of%20a%20concert%20venue%2C%20dim%20lighting%2C%20long%20shadows%2C%20concert%20posters%20on%20walls%2C%20dramatic%20mood%2C%20empty%20hallway%20with%20eerie%20atmosphere%2C%20editorial%20photography&width=800&height=500&seq=carousel-05-hl&orientation=landscape',
    date: '2026-07-25',
  },
  {
    id: 6,
    tag: '重磅实锤',
    title: '顶流带货主播偷税漏税细节全曝光，金额高达九位数',
    summary: '税务部门最新通报显示，某平台头部带货主播通过多个壳公司转移收入，累计偷逃税款数额惊人……',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20office%20scene%20with%20stacks%20of%20documents%20and%20financial%20papers%20scattered%20on%20a%20desk%2C%20calculator%20and%20red%20seals%2C%20dramatic%20lighting%2C%20moody%20atmosphere%2C%20editorial%20photography%20style%2C%20warm%20dark%20tones&width=800&height=500&seq=carousel-06-hl&orientation=landscape',
    date: '2026-07-24',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              重磅焦点
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {carouselItems.map((item) => (
              <article
                key={item.id}
                className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-colors cursor-pointer"
              >
                <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute top-3 left-3 text-[10px] font-semibold bg-primary-500 text-background-50 px-2 py-1 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-bold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {item.summary}
                  </p>
                  <div className="mt-3 flex items-center gap-2 text-[11px] text-foreground-400">
                    <i className="ri-time-line"></i>
                    <span>{item.date}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}